const updateMealTypeUrlToCustom = ({ state }) => {
  state.mealPlanPresetId = null
  const selectedCategory = state.mealPlanSelector.find(({ id }) => id == null)
  state.mealPlanUrl = selectedCategory.url
  state.categoryTags = selectedCategory.tagIds
}

export default updateMealTypeUrlToCustom
